import React, { useEffect, useState } from 'react'
import { v4 as uuid } from "uuid";
import './addnewclient.css'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axiosinstances, { baseURL } from '../../Helper/useAxios';

import { checkDob, checkEmailId, checkMobileNumber, checkName, isUserAdmin } from '../../utils/comman/Common';
const RETAILER_DETAILS = "RETAILER_DETAILS"
const VARIFICATION = 'VARIFICATION'
const BUSINESS_DETAILS = 'BUSINESS_DETAILS'
const DOCUMENT_UPLOAD = 'DOCUMENT_UPLOAD'
const BANK_DEATILS = 'BANK_DEATILS'
const PASSWORD = "PASSWORD"
const SEARCHIFSC = "SEARCHIFSC"
const USERCREATED = 'USERCREATED'
export default function AddNewClient() {
	const token = JSON.parse(sessionStorage.getItem("token"));
	const baseUrl = baseURL
	//console.log('baseUrl', baseUrl)
	const requesterId = useSelector((state) => state.selectedretailerReqesterReducer.requesterId);
	const [axiosInstance] = axiosinstances()
	const [isFnameCorrect, setIsFnameCorrect]= useState(false)
	const [isLnameCorrect, setIsLnameCorrect]= useState(false)
	const [isMobileCorrect, setIsMobileCorrect] = useState(false)
	const [isEmailCorrect, setIsEmailCorrect] = useState(false)
	const [isDobCorrect, setIsDobCorrect] =useState(false)
	const [isShopNameCorrect,setIsShopNameCorrect] = useState(false)
	const [documentName, setDocumentName] = useState('')
	const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
	const [addnewRetailer, setAddNewRetailer] = useState(RETAILER_DETAILS)
    const new_id  = useSelector((state) => state.getprofilereducer?.getprofile?.id);
	const [password, setpassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')	
    const navigate = useNavigate();
	const [bankHistory, setBankHistory] = useState()
	const [roCode, setRoCode] = useState({roid:'', clientDetails:''})
	const [authenticatedSession, setAuthenticatedSession] = useState()
	const [fileInfo, setFileInfo] = useState({
		href:'',
		id:'',
		name:'',
		type:''
	})
	const [allfileInfo, setAllFileInfo] = useState([{
		id:'',
		type:'COMPANY_DOCUMENTS',
		url:''
	},{
		id:'',
		type:'GST_CERTIFICATE',
		url:''
	},{
		id:'',
		type:'PAN_CARD',
		url:''
	},
	{
		id:'',
		type:'AGREEMENT',
		url:''
	},
	{
		id:'',
		type:'CANCELED_CHEQUE',
		url:''
	}
 ])
 //console.log('allfileInfo', allfileInfo)
	const [selectedFile, setSelectedFile] = useState()
	const [sessionDetails, setSessionDetails ] = useState({sessionId:''})
	const [otp, setOtp] = useState('')
	const [confirmAcc, setConFirmAcc] = useState('')
	const [allBankname, setAllbankname] = useState([])
	const [selectedBank, setSelectedbank] = useState('')
	const [stateDetails, setStateDetails] = useState([])
	const [cities, setCities] = useState([])
	const [branches, setBranches] = useState([])
	//console.log()
	const [ifsc, setIfsc] = useState('')
	const [searched, setSearched] =useState({
		name: '',
		typing: false,
		typingTimeout: 0
	  })
	const href = fileInfo.href
	let unique_id = '';
	//console.log('selectedBank', selectedBank)
	const [personalDetails, setPersonalDetails] = useState({
		personalInfo:{
			fname: "",
			lname: "",
			email: "",
			mobile: "",
			dob :"",
			gender: "",
			address:null
		},
		shopDetails:{
			name: "",
			email: '',
			mobile: "",
			type: "",
			address:{
				fullAddress: "",
				add1: "",
				add2: "",
				city: "",
				district: "",
				state: "",
				pincode: "",
				location:{
					type:'Point',
					coordinates:[0, 0]
				}
			},
			shopPic: ''
		},
		accountInfo:{
			bank: '',
			branch: "",
			accNum: "",
			ifsc: ""
		},
		kycInfo: 
		{
			docs:
			[
			],
			bankKycId: "",
			acquiringBank: ""
		},
		"type": "CORP"
	})
useEffect(() => {
	unique_id=uuid()
}, [])
//console.log('allfileInfo', allfileInfo)
const goBack = () =>{
    ///clients
    navigate('/clients')
}
//console.log('fileInfo', fileInfo)
//console.log('selectedFile', selectedFile)
//console.log('personalDetails', personalDetails)
//console.log('isFnameCorrect', isFnameCorrect)
const getBankHistory = () =>{
	axiosInstance.get(`/api/v1/catalog/bank/all/summary`,   {
		headers: { Authorization: `Bearer ${token}`,
		"client-id": id, role: "ROLE_RETAILER_FINXPAY"}
	  } )
		.then((res)=>{
			//console.log('res-->', res)
			setAllbankname(res?.data)
		})
		.catch((err)=>console.log(err))
} 
useEffect(()=>{
if(addnewRetailer === SEARCHIFSC || addnewRetailer === BANK_DEATILS ){
	getBankHistory()
}
},[addnewRetailer])
const getBankDetailsWithId = async (bankId) =>{
	 await axiosInstance.get(`/api/v1/catalog/bank/${bankId}`,   {
		headers: { Authorization: `Bearer ${token}`,
		"client-id": id,}
	  } )
		.then((res)=>{
			//console.log('resp---> ', res.data?.states)
			setStateDetails(res.data?.states)
		})
		.catch((err)=>console.log(err))
} 
// let stateDetails = []


//  useEffect(() =>{
//  if(selectedBank !== undefined && selectedBank !== null && selectedBank !== '' ){
// 	 getBankDetailsWithId(selectedBank);
//  } else {
// 	return []
//  }
// }, 
//   [selectedBank])
const docChange = (e, check) =>{
const {name, value} = e.target
let temp = [...allfileInfo]
let index = allfileInfo.findIndex(x => x.type ===name)
temp[index].id = value

setAllFileInfo(temp)


}
// const docValues = (check)=>{

// //console.log('values', values)
// if(values.length !== 0){
// 	return values[0].type
// } else{
// return ''
// }
// }
// //console.log('ram', docValues("COMPANY_DOCUMENTS")) 
useEffect(()=>{
	if(selectedBank !== ''){
		getBankDetailsWithId(selectedBank);
	}
	},[selectedBank])
//console.log('stateDetails', stateDetails)
    // const namereg = /^[A-Za-z.\s_-]+$/
    // const mobileReg = /^[0-9]{10}$/
    // const emailReg = /^\S+@\S+\.\S+$/
    // const validate = Yup.object({
    //     companyName: Yup.string().required("Enter Valid Name"),
    //     contactPerson: Yup.string()
    //     .matches(namereg, 'Enter Valid Name')
    //     .required("Contact Persion name Is Required"),
    //     mobileNumber: Yup.string()
    //     .matches(mobileReg, 'Enter Valid Mobile Number')
    //     .required("Mobile number Is Required"),
    //     companyEmail: Yup.string()
    //     .matches(emailReg, 'Enter Valid Email Id')
    //     .required("Email Is Required"),
    //     companyPan: Yup.string().required("PAN/TAN Mode Is Required"),
    //     companyGst: Yup.string().required("GST Is Required"),

    //     companyAddress: Yup.string().required("Address Is Required"),
        
    //   });
	const date = new Date()
	
	const createSession = async () => {
		const response = await axiosInstance
		.post(`/api/v1/retailer/onboard/session/create`,
		{
			header: {
				Authorization: `Bearer ${token}`,
				"client-id": id,
				"msgType": "CREATE_RETAILER",
				"service": "ONBOARDING",
				"channel": "ADMIN",
				"requesterId": requesterId,
				"requestId": unique_id,
				 "time": date
			  },
			  mobile:personalDetails?.personalInfo?.mobile !== undefined ? personalDetails?.personalInfo?.mobile : ''
		})
	   .then((res) => {
		//console.log('res', res)
		setSessionDetails(res.data)
		setAddNewRetailer(VARIFICATION)
	   })
	   .catch((err) => {
		 //console.log(err);
		 
	   });
	
		if (response) {
		  const result = response.data.orders;
		  
		  if (result) {
		  }
	
		  return response.data;
		}
		return false;
	  };

	  const authenticateSession = async () => {
		const response = await axiosInstance
		.post(`/api/v1/retailer/onboard/session/authenticate`,
		{
				header : {
				Authorization: `Bearer ${token}`,
				"client-id": id,
				  msgType : "CREATE_RETAILER",
				  service : "ONBOARDING",
				  src : null,
				  dst : null,
				  channel : "ADMIN",
				  requesterId : requesterId,
				  requestId : unique_id,
				  time : date,
				  traceId : sessionDetails?.traceId,
				  hops : null
				},
				"sessionId" : sessionDetails?.sessionId,
				"otpDetails" : {
				  "mobile" : personalDetails?.personalInfo?.mobile !== undefined ? personalDetails?.personalInfo?.mobile : '',
				  "type" : "ONBOARDING_SESSION_CREATED",
				  "refNo" : sessionDetails.otpDetails.refNo,
				  "otp" : otp
				
			  } 
		})
	   .then((res) => {
		//console.log('res', res)
		setAddNewRetailer(BUSINESS_DETAILS)
	   })
	   .catch((err) => {
		 //console.log(err);
		 
	   });
	
		if (response) {
		  const result = response.data.orders;
		  
		  if (result) {
		  }
	
		  return response.data;
		}
		return false;
	  };
//console.log('all', allfileInfo)
	  const saveInformation = async (check) => {
		const details = check === BUSINESS_DETAILS ? {personalInfo : personalDetails.personalInfo, shopDetails: personalDetails.shopDetails } : check === DOCUMENT_UPLOAD ? {kycInfo: 
			{
				docs:allfileInfo,
				bankKycId: "",
				acquiringBank: ""
			}} : check === BANK_DEATILS ? { accountInfo : personalDetails.accountInfo }: {}
			//console.log('details', details)
		const response = await axiosInstance
		.post(`/api/v1/retailer/onboard/session/save`,
		{
				header : {
				Authorization: `Bearer ${token}`,
				"client-id": id,
				"msgType" : "CREATE_RETAILER",
				"service" : "ONBOARDING",
				"src" : null,
				"dst" : null,
				"channel" : "ADMIN",
				"requesterId" : requesterId,
				"requestId" : unique_id,
				"time" : date,
				"traceId" : sessionDetails?.traceId,
				"hops" : null
				},
				"sessionId" : sessionDetails?.sessionId,
				...details
		})
	   .then((res) => {
		//console.log('res-->', res)
		
		if(check=== RETAILER_DETAILS){
			setAddNewRetailer(VARIFICATION)
			
		} else if(check === VARIFICATION){
			setAddNewRetailer(BUSINESS_DETAILS)
		} else if(check === BUSINESS_DETAILS){
			 setAddNewRetailer(DOCUMENT_UPLOAD)
			
		} else if(check === DOCUMENT_UPLOAD){
			
			 setAddNewRetailer(BANK_DEATILS)
		} else if(check === BANK_DEATILS){
			setAddNewRetailer(PASSWORD)
		}
	   })
	   .catch((err) => {
		 //console.log(err);
		 
	   });
	
		if (response) {
		  const result = response.data.orders;
		  
		  if (result) {
		  }
	
		  return response.data;
		}
		return false;
	  };

const createUser = async (roId) => {
		
	const response = await axiosInstance
	.post(`/auth/user/create`,
	{
			header : {
			Authorization: `Bearer ${token}`,
			"client-id": id,
			"msgType" : "CREATE_RETAILER",
			"service" : "ONBOARDING",
			"src" : null,
			"dst" : null,
			"channel" : "ADMIN",
			"requesterId" : requesterId,
			"requestId" : unique_id,
			"time" : date,
			"traceId" : sessionDetails?.traceId,
			"hops" : null
			
			},
			// "sessionId" : sessionDetails?.sessionId,
			"clientName": personalDetails.shopDetails.name,
			'username': uuid(),
			"password":uuid(),
			'role':'ROLE_THIRD_PARTY',
			'encrypted':false,
			'roId':roId

	})
   .then((res) => {
	//console.log('user created res-->', res)
	setRoCode((prev)=>({...prev, clientDetails:res.data}))
	 setAddNewRetailer(USERCREATED)
	 
   })
   .catch((err) => {
	 //console.log(err);
	 
   });

	if (response) {
	  const result = response.data.orders;
	  
	  if (result) {
	  }

	  return response.data;
	}
	return false;
  };
 const createRetailer = async (check) => {
		
		const response = await axiosInstance
		.post(`/api/v1/retailer/onboard/session/finalize`,
		{
				header : {
				Authorization: `Bearer ${token}`,
				"client-id": id,
				"msgType" : "CREATE_RETAILER",
				"service" : "ONBOARDING",
				"src" : null,
				"dst" : null,
				"channel" : "ADMIN",
				"requesterId" : requesterId,
				"requestId" : unique_id,
				"time" : date,
				"traceId" : sessionDetails?.traceId,
				"hops" : null
				
				},
				"sessionId" : sessionDetails?.sessionId,
				password: password
		})
	   .then((res) => {
		//console.log('res-->', res)
		setRoCode((prev)=>({...prev, roid:res.data?.retailerId}))
		 createUser(res.data?.retailerId)
	   })
	   .catch((err) => {
		 //console.log(err);
		 
	   });
	
		if (response) {
		  const result = response.data.orders;
		  
		  if (result) {
		  }
	
		  return response.data;
		}
		return false;
	  };
const handleSubmit = (e,check) =>{
	e.preventDefault()
	//console.log('check', check)
	if(check=== RETAILER_DETAILS){
		//
		createSession()
	} else if(check === VARIFICATION){
		authenticateSession()
		//setAddNewRetailer(BUSINESS_DETAILS)
	} else if(check === BUSINESS_DETAILS){
		// setAddNewRetailer(DOCUMENT_UPLOAD)
		saveInformation(BUSINESS_DETAILS)
	} else if(check === DOCUMENT_UPLOAD){
		saveInformation(DOCUMENT_UPLOAD)
		// setAddNewRetailer(BANK_DEATILS)
	} else if(check === BANK_DEATILS){
		saveInformation(BANK_DEATILS)
		
	} else if(check === PASSWORD){
		createRetailer(PASSWORD)
	}
	
}
//console.log('personalDetails', personalDetails)
const handlerInfoChnage = (e,check) =>{
	const {name, value} = e.target         
	if(check === RETAILER_DETAILS){
		if(name==='email'){
			setIsEmailCorrect(!checkEmailId(value))
			setPersonalDetails({
				...personalDetails,
				 ...personalDetails.shopDetails,
				 ...personalDetails.shopDetails.email=value
				 
				})	
		} else if( name === 'fname'){
			setIsFnameCorrect(!checkName(value))
			////console.log('chhhhee',value, checkName(value))
		} else if(name === 'lname'){
			setIsLnameCorrect(!checkName(value))
		} else if(name==='mobile'){
			setIsMobileCorrect(!checkMobileNumber(value))
		}else if(name=='dob'){
			setIsDobCorrect(!checkDob(value))
		}
		setPersonalDetails({
			...personalDetails,
			personalInfo:{
			...personalDetails.personalInfo,
			[name]: value
	}})
	
	} else if(check === BUSINESS_DETAILS){
		let temp = {...personalDetails}
		if(name == 'add1'){
			temp.shopDetails.address.add1 = value
			setPersonalDetails(temp)
		} else if(name == 'add2'){
			temp.shopDetails.address.add2 = value
			setPersonalDetails(temp)
			
		} else if(name == 'state'){
			temp.shopDetails.address.state = value
			setPersonalDetails(temp)
		} else if(name == 'city'){
			temp.shopDetails.address.city = value
			setPersonalDetails(temp)
			
		} else if(name=='pincode'){
			temp.shopDetails.address.pincode = value
			setPersonalDetails(temp)	
		}else{
		
			setPersonalDetails({
						...personalDetails,
						shopDetails:{
						...personalDetails.shopDetails,
						[name]: value
				}})
		}
		
	// 	setPersonalDetails({
	// 		...personalDetails,
	// 		shopDetails:{
	// 		...personalDetails.shopDetails,
	// 		[name]: value
	// }})
	} else if(check === BANK_DEATILS){
		//console.log('save BANK_DEATILS')
		setPersonalDetails({
			...personalDetails,
			accountInfo:{
			...personalDetails.accountInfo,
			[name]: value
	}})	
	}

}
const updateUrl = () =>{
	
}
//console.log('roCode', roCode)
const uploadFiles = (reqData) =>{
	
	axiosInstance.post(`api/v1/document`, reqData,  {
		headers: { 'Content-Type': 'multipart/form-data' }
	  } )
		.then((res)=>{
			if(documentName === "LOGO"){
				setFileInfo({
					id: res.data?.id,
					name: res.data?.name,
					type: res.data?.type,
					href: res.data?.href
					})
					// setPersonalDetails({
					// 	...personalDetails,
					// 	 ...personalDetails.shopDetails,
					// 	 shopDetails.shopPic:baseURL + res.data?.href
						 
					// 	})
					const temp = {...personalDetails}
					temp.shopDetails.shopPic = baseURL + res.data?.href
					setPersonalDetails(temp)
			} else{
				let index = allfileInfo.findIndex(x => x.type ===res.data?.name)
				
				if(index == -1){
					
					let temp = [...allfileInfo]
					//console.log('temp1', temp)
					temp[index].type = res.data?.name
					temp[index].url = baseURL + res.data?.href
					setAllFileInfo(temp)
					
				} else{
					
					let temp = [...allfileInfo]
					//console.log('temp2', temp)
					temp[index].type = res.data?.name
					temp[index].url = baseURL + res.data?.href
					setAllFileInfo(temp)
					// setAllFileInfo([
					// 	...allfileInfo,
					// 	{
					// 	  id: '',
					// 	  // name: res.data?.name,
					// 	  type: res.data?.name,
					// 	  url: baseURL + res.data?.href,
					// 	},
					//   ]);
				}
				
			}
		  
		  const href = baseURL+res.data?.href
		//   setPersonalDetails({
			
		// 	...personalDetails.shopDetails.shopPic=href
			 
			 
		// 	})
		})
		.catch((err)=>console.log(err))
}
const filterImage = (data, check)=>{
 const filterImg= data.filter((val)=>val.type === check )
 return filterImg[0]?.url !== '' ? filterImg[0]?.url : undefined
}
useEffect(() => {
    if (selectedFile !== undefined) {
      const fileDetails = {
        doc: selectedFile,
        name: documentName,
        type: "img",
      };
	  uploadFiles(fileDetails);
    }
  }, [selectedFile]);
//   const getBankIfsc = (data) =>{
// 	//console.log('data', data)
// 	Array.isArray(data.states) && Array.isArray(data.states[0].cities) &&
// 	 data.states.map((values, index)=>{
// 		//console.log('values', values)
// 		Array.isArray(values.cities) && values.cities.map((cities)=>{
// 			////console.log('city', cities)
// 		})
// 	 })
// } 
 const cityHandler = (e) =>{
	const index=  e.target.value
	const city =stateDetails[index].cities
    setCities(city)
 } 
 const banchHandler = (e) =>{
	//console.log('clickSlect', e.target.value)
	const index = e.target.value
	const branch = cities[index].branches
	setBranches(branch)
 }
 const ifscHandler = (e) =>{
	//console.log('eee', e.target.value)
	const index =  e.target.value
	const branch = branches[index]
	//console.log('branches', branch)
	setPersonalDetails({
		...personalDetails,
		accountInfo:{
			...personalDetails.accountInfo,
		ifsc :	 branch.ifsc,
		branch:branch.name, 
		bank: selectedBank
		
}})
 }
 const submitIfsc = (e)=>{
	e.preventDefault()
	setAddNewRetailer(BANK_DEATILS)
 }

  const searchedHadler = (event) =>{

	if (searched.typingTimeout) {
	  clearTimeout(searched.typingTimeout);
   }
  if(!searched.typing){
	setBankHistory([])
  }
   setSearched({
	  name: event.target.value,
	  typing: true,
	  typingTimeout: setTimeout(function () {
		  // sendToParent(searched.name);
		  if(event.target.value !== ''){
			//getBankHistory(event.target.value)
		  } else{
			setBankHistory([]) 
			// sessionStorage.removeItem('rname')
			// sessionStorage.removeItem('rid')
			//dispatch(selectedRetailer(null))
		  }
		}, 1200)
   });
  }
const changeFileHandler = (event) => {
    setSelectedFile(event.target.files[0]);
	setDocumentName('LOGO')
  };
  //changeUploadFileHandler
  const changeUploadFileHandler = (event,data) => {
	
    setSelectedFile(event.target.files[0]);
	setDocumentName(data)
  };
const onInputClick = (event) => {
    event.target.value = "";
  };
  const checkPersonalDisable = () =>{
	let disabled = true
	if(!isFnameCorrect && !isLnameCorrect && personalDetails.personalInfo.dob !== '' && personalDetails.personalInfo.gender !== ''  && !isMobileCorrect){
		disabled = false
	} else{
		disabled = true
	}
	return disabled
  }

  const checkShopDisable = () =>{
	let disabled = true
	if(personalDetails.shopDetails.name !== '' && personalDetails.shopDetails.type !== '' && personalDetails.shopDetails.address.add1 !== ''&&
	 personalDetails.shopDetails.address.state !== '' && personalDetails.shopDetails.address.city !== '' && personalDetails.shopDetails.address.pincode !== ''){
		disabled = false
	} else{
		disabled = true
	}
	return disabled
  }
  const checkBankDisable = () =>{
	let disabled = true
	if(personalDetails.accountInfo.bank !== '' && personalDetails.accountInfo.accNum !== '' && personalDetails.accountInfo.ifsc !== '' && personalDetails.accountInfo.accNum == confirmAcc){
		disabled = false
	} else{
		disabled = true
	}
	return disabled
  }
  const checkPassDisable = () =>{
	let disabled = true
	if(confirmPassword.length > 1 && password == confirmPassword){
		disabled = false
	} else{
		disabled = true
	}
	return disabled
  }

  const nextPage = () =>{
	navigate('/retailer-list')
  }
 const docidValues = (data) =>{
	const value = allfileInfo.filter(val=>val.type === data)
	return value[0]?.id !== undefined ? value[0]?.id : ''
 }
  return (
    <React.Fragment>
	{
	isUserAdmin(id) &&	addnewRetailer === RETAILER_DETAILS ?
		<div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2>Register as a retailer</h2>
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onSubmit={(e)=>handleSubmit(e,RETAILER_DETAILS)} >
							<div class="row">								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="firsname" name='fname' placeholder="Enter first name" onChange={(e)=>handlerInfoChnage(e,RETAILER_DETAILS)} value={personalDetails.personalInfo.fname} />
										<label for="firsname">First name</label>
										{ personalDetails.personalInfo.fname.length > 2 && isFnameCorrect &&	<small style={{color:'red'}} >Enter Valid First Name</small>}
									</div>
									
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="lastname" placeholder="Enter last name" name='lname'  onChange={(e)=>handlerInfoChnage(e,RETAILER_DETAILS)} value={personalDetails.personalInfo.lname}/>
										<label for="lastname">Last name</label>
										{personalDetails.personalInfo.lname.length > 2 && isLnameCorrect &&	<small style={{color:'red'}} >Enter Valid Last Name</small>}
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="mobile" placeholder="Enter mobile no." name='mobile' onChange={(e)=>handlerInfoChnage(e,RETAILER_DETAILS)} value={personalDetails.personalInfo.mobile}/>
										<label for="mobile">Mobile number</label>
					
										{personalDetails.personalInfo.mobile.length > 1 && isMobileCorrect &&	<small style={{color:'red'}} >Enter Valid Mobile Number</small>}
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="email" placeholder="Enter email id" name='email' onChange={(e)=>handlerInfoChnage(e,RETAILER_DETAILS)} value={personalDetails.personalInfo.email}/>
										<label for="email">Email ID</label>
										{ personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>}
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="date" class="form-control" id="dob" placeholder="Date of Birth" name='dob' onChange={(e)=>handlerInfoChnage(e,RETAILER_DETAILS)} value={personalDetails.personalInfo.dob}/>
										<label for="dob">Date of Birth</label>

										{/* {isDobCorrect &&	<small style={{color:'red'}} >Enter Valid DOB</small>} */}
									</div>
								</div>
								
								<div class="col-12 col-md-6">							
									<div class="form-checkbox">
										<label class="label-txt">Gender </label>
								
										<div class="form-check form-check-inline">
											<input class="form-check-input" type="radio" name="gender"  onChange={(e)=>handlerInfoChnage(e,RETAILER_DETAILS)} id="male" value="MALE"/>
											<label class="form-check-label" for="male">Male</label>
										</div>
										<div class="form-check form-check-inline">
											<input class="form-check-input" type="radio" name="gender" id="female"  onChange={(e)=>handlerInfoChnage(e,RETAILER_DETAILS)} value="FEMALE"/>
											<label class="form-check-label" for="female">Female</label>
										</div>
										<div class="form-check form-check-inline">
											<input class="form-check-input" type="radio" name="gender" id="other"  onChange={(e)=>handlerInfoChnage(e,RETAILER_DETAILS)} value="OTHER"/>
											<label class="form-check-label" for="other">Other</label>
										</div>
										
									</div>
									{/* {personalDetails.personalInfo.gender == ''  &&	<small >Select one Gender option</small>} */}
								</div>							
								
								<div class="col-12 mt-4">
									<div class="form-check">
										<input class="form-check-input" type="checkbox" value="" id="tnc" checked/>
										<label class="form-check-label tnc" for="tnc">By registering, you confirm that you accept our <a href="#">terms and conditions</a></label>
									</div>
								</div>
								
								<div class="col-12">
									<button disabled={checkPersonalDisable()} type="submit" class="btn btn-primary" id="">Proceed</button>
								</div>								
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
        </div> : addnewRetailer === VARIFICATION ?
	 <div class="mid-contant">
	 <div class="container">		
		 <div class="row">
			 <div class="col-12">
				 <div class="head">
					 <h2>Verify Mobile number</h2>
				 </div>
			 </div>
			 
			 <div class="col-12">
				 <div class="registerbox">
					 <div class="row mb-3">
						 <div class="col-12 col-lg-7">
							 <form  onSubmit={(e)=>handleSubmit(e,VARIFICATION)} >
							 <div class="row">
							 
								 <div class="col-12">
									 <div class="otptxt">Enter the 6 digit OTP sent to your mobile number: +91-{personalDetails.personalInfo.mobile}</div>
								 </div>
								 
								 <div class="col-12 col-md-8">
									 <div class="form-floating">
										 <input type="text" class="form-control" id="otp" placeholder="Enter OTP" onChange={(e)=>setOtp(e.target.value)} value={otp}/>
										 <label for="otp">Enter OTP</label>
									 </div>
								 </div>
								 
								 <div class="col-6 col-md-5">
									 <button disabled={otp.length == ''}  type="submit" class="btn btn-primary" id="">Verify Now</button>
								 </div>
								 
								 {/* <div class="col-6 col-md-7">
									 <button type="button" class="btn btn-trp" id="">Resend OTP</button>
								 </div>							 */}
								 
								 <div class="col-12 mt-4 d-none">
									 <div class="spinner-border spinner-border-sm text-primary" role="status">
										 <span class="visually-hidden">Loading...</span>
									 </div>									
									 <div class="timmer">45</div>
								 </div>
							 </div>
							 </form>							
						 </div>
						 
						 <div class="col-12 col-lg-5 d-none d-lg-block border-start">
							 <div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						 </div>				
					 </div>
				 </div>
			 </div>
		 </div>
	 </div>
 </div> : addnewRetailer === BUSINESS_DETAILS ? 
    <div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2> Retailer Business Details</h2>
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onSubmit={(e)=>handleSubmit(e,BUSINESS_DETAILS)}  >
							<div class="row">								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="name" placeholder="Enter shop name" name='name'  onChange={(e)=>handlerInfoChnage(e,BUSINESS_DETAILS)} value={personalDetails.shopDetails.name}/>
										<label for="nmae">Business name</label>
										{personalDetails.personalInfo.lname.length > 2 && isLnameCorrect &&	<small style={{color:'red'}} >Enter Valid Last Name</small>}
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select" id="type" name='type' onChange={(e)=>handlerInfoChnage(e,BUSINESS_DETAILS)} value={personalDetails.shopDetails.type} >
											<option value="">Select</option>
											<option value="PARTNERSHIP">Partnership</option>
											<option value="PVT_LTD">Pvt Ltd</option>
											<option value="SOLE_PROPRIETOR">Sole Proprietor</option>
										</select>
										<label for="type">Select Shop Type</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="add1" placeholder="Enter Address" name='add1' onChange={(e)=>handlerInfoChnage(e,BUSINESS_DETAILS)} value={personalDetails.shopDetails.address.add1}/>
										<label for="add1">Address line 1</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="add2" placeholder="Enter Address" name='add2' onChange={(e)=>handlerInfoChnage(e,BUSINESS_DETAILS)} value={personalDetails.shopDetails.address.add2}/>
										<label for="add2">Address line 2</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">						
								<div class="form-floating">
									<select class="form-select" id="state" name='state' onChange={(e)=>handlerInfoChnage(e,BUSINESS_DETAILS)} value={personalDetails.shopDetails.address.state}>
										<option value="">Select</option>
										<option value="Andhra Pradesh">Andhra Pradesh</option>
										<option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
										<option value="Arunachal Pradesh">Arunachal Pradesh</option>
										<option value="Assam">Assam</option>
										<option value="Bihar">Bihar</option>
										<option value="Chandigarh">Chandigarh</option>
										<option value="Chhatisgarh">Chhatisgarh</option>
										<option value="Dadra and Nagar Haveli">Dadra and Nagar Haveli</option>
										<option value="Daman and Diu">Daman and Diu</option>
										<option value="Delhi NCR">Delhi NCR</option>
										<option value="Goa">Goa</option>
										<option value="Gujarat">Gujarat</option>
										<option value="Haryana">Haryana</option>
										<option value="Himachal Pradesh">Himachal Pradesh</option>
										<option value="Jammu & Kashmir">Jammu & Kashmir</option>
										<option value="Jharkhand">Jharkhand</option>
										<option value="Karnataka">Karnataka</option>
										<option value="Kerala">Kerala</option>
										<option value="Ladakh">Ladakh</option>
										<option value="Lakshadweep">Lakshadweep</option>
										<option value="Madhya Pradesh">Madhya Pradesh</option>
										<option value="Maharashtra">Maharashtra</option>
										<option value="Manipur">Manipur</option>
										<option value="Mizoram">Mizoram</option>
										<option value="Nagaland">Nagaland</option>
										<option value="Odisha">Odisha</option>
										<option value="Puducherry">Puducherry</option>
										<option value="Punjab">Punjab</option>
										<option value="Rajasthan">Rajasthan</option>
										<option value="Sikkim">Sikkim</option>
										<option value="Tamilnadu">Tamilnadu</option>
										<option value="Telangana">Telangana</option>
										<option value="Tripura">Tripura</option>
										<option value="Uttar Pradesh">Uttar Pradesh</option>
										<option value="Uttarakhand">Uttarakhand</option>
										<option value="West Bengal">West Bengal</option>
									</select>
									<label for="state">Select state</label>
								</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="city" placeholder="Enter City" name='city' onChange={(e)=>handlerInfoChnage(e,BUSINESS_DETAILS)} value={personalDetails.shopDetails.address.city}/>
										<label for="city">City name</label>
									</div>
								</div>
								
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="pincode" placeholder="Enter pincode" name='pincode' onChange={(e)=>handlerInfoChnage(e,BUSINESS_DETAILS)} value={personalDetails.shopDetails.address.pincode} />
										<label for="pincode">Pincode</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
										<div class="file-upload">	
											<div class="dropzone-wrapper">
												<div class="dropzone-desc">
													<i class="camera"></i>
													<h6>Upload Shop Photo</h6>													
												</div>
												<input
                                            type="file"
                                            name="fileup"
                                            class="dropzone"
                                            onChange={changeFileHandler}
                                            onClick={onInputClick}
                                          />
												{/* <input type="file" name="fileup" class="dropzone"/> */}
											</div>	
											{
									 selectedFile !== undefined &&	
									 <div className="upload-image-thumnail" >
									<img class="img-thumbnail"  src={ URL.createObjectURL(selectedFile)} alt={'logo'}/>
									</div>
									}										
										</div>
									</div>
								
								<div class="col-12">
									<button disabled={checkShopDisable()} type="submit" class="btn btn-primary" id="">Proceed</button>
								</div>								
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
</div> : addnewRetailer === DOCUMENT_UPLOAD ? 
 <div class="mid-contant">
 <div class="container">		
	 <div class="row">
		 <div class="col-12">
			 <div class="head">
				 <h2>ID Details & Upload</h2>
			 </div>
		 </div>
		 
		 <div class="col-12">
			 <div class="registerbox">
				 <div class="row mb-3">
					 <div class="col-12 col-lg-7">
						 <form onSubmit={(e)=>handleSubmit(e,DOCUMENT_UPLOAD)}>
							 <div class="row">
								 <div class="col-12 col-lg-7">
									 <div class="form-floating">
										 <input type="text" class="form-control" id="CDOC" placeholder="Enter" name='COMPANY_DOCUMENTS' onChange={(e)=>docChange(e,"COMPANY_DOCUMENTS")}  value={docidValues('COMPANY_DOCUMENTS')}/>
										 <label for="CDOC">COMPANY DOCUMENTS</label>
									 </div>
								 </div>
							 
								 <div class="col-12 col-lg-5">
									 <div class="file-upload">	
										 <div class="dropzone-wrapper">
											 <div class="dropzone-desc">
												 <i class="camera"></i>
												 <h6>Upload Document</h6>													
											 </div>
											 <input
                                            type="file"
                                            name="fileup"
                                            class="dropzone"
                                            onChange={(e)=>changeUploadFileHandler(e,'COMPANY_DOCUMENTS')}
                                            onClick={onInputClick}
                                          />
										 </div>	
										 
										 {
									 allfileInfo !== undefined && allfileInfo.length > 0 && filterImage(allfileInfo,'COMPANY_DOCUMENTS') !== undefined &&
									 	
									 <div className="upload-image-thumnail" >
									<img class="img-thumbnail"  src={filterImage(allfileInfo,'COMPANY_DOCUMENTS') } alt={'COMPANY_DOCUMENTS'}/>
									</div>
									}										
									 </div>
									
								 </div>
								
								 <div class="col-12 col-lg-7">
									 <div class="form-floating">
										 <input type="text" class="form-control" id="GST" placeholder="Enter GST ID" name='GST_CERTIFICATE' onChange={(e)=>docChange(e,"GST_CERTIFICATE")}  value={docidValues('GST_CERTIFICATE')}/>
										 <label for="GST">GST CERTIFICATE</label>
									 </div>
								 </div>
							 
								 <div class="col-12 col-lg-5">
									 <div class="file-upload">	
										 <div class="dropzone-wrapper">
											 <div class="dropzone-desc">
												 <i class="camera"></i>
												 <h6>Upload GST</h6>													
											 </div>
											 <input
                                            type="file"
                                            name="fileup"
                                            class="dropzone"
                                            onChange={(e)=>changeUploadFileHandler(e,'GST_CERTIFICATE')}
                                            onClick={onInputClick}
                                          />
										 </div>	
										 
										 {
									 allfileInfo !== undefined && allfileInfo.length > 0 && filterImage(allfileInfo,'GST_CERTIFICATE') !== undefined &&
									 	
									 <div className="upload-image-thumnail" >
									<img class="img-thumbnail"  src={filterImage(allfileInfo,'GST_CERTIFICATE') } alt={'GST_CERTIFICATE'}/>
									</div>
									}										
									 </div>
								 </div>
								 <div class="col-12 col-lg-7">
									 <div class="form-floating">
										 <input type="text" class="form-control" id="pan" placeholder="Enter" name='PAN_CARD' onChange={(e)=>docChange(e,"PAN_CARD")}  value={docidValues('PAN_CARD')}   />
										 <label for="pan">PAN CARD</label>
									 </div>
								 </div>
							 
								 <div class="col-12 col-lg-5">
									 <div class="file-upload">	
										 <div class="dropzone-wrapper">
											 <div class="dropzone-desc">
												 <i class="camera"></i>
												 <h6>Upload Pan Card</h6>													
											 </div>
											 <input
                                            type="file"
                                            name="fileup"
                                            class="dropzone"
                                            onChange={(e)=>changeUploadFileHandler(e,'PAN_CARD')}
                                            onClick={onInputClick}
                                          />
										 </div>	
										 {
									 allfileInfo !== undefined && allfileInfo.length > 0 && filterImage(allfileInfo,'PAN_CARD') !== undefined &&
									 	
									 <div className="upload-image-thumnail" >
									<img class="img-thumbnail"  src={filterImage(allfileInfo,'PAN_CARD') } alt={'PAN_CARD'}/>
									</div>
									}										
									 </div>
								 </div>

								 <div class="col-12 col-lg-7">
									 <div class="form-floating">
										 <input type="text" class="form-control" id="AGR" placeholder="Enter AGREEMENT ID" name='AGREEMENT' onChange={(e)=>docChange(e,"AGREEMENT")}  value={docidValues('AGREEMENT')} />
										 <label for="AGR">AGREEMENT</label>
									 </div>
								 </div>
							 
								 <div class="col-12 col-lg-5">
									 <div class="file-upload">	
										 <div class="dropzone-wrapper">
											 <div class="dropzone-desc">
												 <i class="camera"></i>
												 <h6>Upload Agreement</h6>													
											 </div>
											 <input
                                            type="file"
                                            name="fileup"
                                            class="dropzone"
                                            onChange={(e)=>changeUploadFileHandler(e,'AGREEMENT')}
                                            onClick={onInputClick}
                                          />
										 </div>	
										 {
									 allfileInfo !== undefined && allfileInfo.length > 0 && filterImage(allfileInfo,'AGREEMENT') !== undefined &&
									 	
									 <div className="upload-image-thumnail" >
									<img class="img-thumbnail"  src={filterImage(allfileInfo,'AGREEMENT')} alt={'AGREEMENT'}/>
									</div>
									}										
									 </div>
								 </div>
								 
								 <div class="col-12 col-lg-7">
									 <div class="form-floating">
										 <input type="text" class="form-control" id="CHEC" placeholder="Enter" name='CANCELED_CHEQUE' onChange={(e)=>docChange(e,"CANCELED_CHEQUE")}  value={docidValues('CANCELED_CHEQUE')}/>
										 <label for="CHEC">CANCELED CHEQUE</label>
									 </div>
								 </div>
								 
								 <div class="col-12 col-lg-5">
									 <div class="file-upload">	
										 <div class="dropzone-wrapper">
											 <div class="dropzone-desc">
												 <i class="camera"></i>
												 <h6>Upload Cheque</h6>													
											 </div>
											 <input
                                            type="file"
                                            name="fileup"
                                            class="dropzone"
                                            onChange={(e)=>changeUploadFileHandler(e,'CANCELED_CHEQUE')}
                                            onClick={onInputClick}
                                          />
										 </div>	
										 {
									 allfileInfo !== undefined && allfileInfo.length > 0 && filterImage(allfileInfo,'CANCELED_CHEQUE') !== undefined &&
									 	
									 <div className="upload-image-thumnail" >
									<img class="img-thumbnail"  src={filterImage(allfileInfo,'CANCELED_CHEQUE') } alt={'CANCELED_CHEQUE'}/>
									</div>
									}										
									 </div>
									 {/* <div class="file-upload">	
										 <div class="dropzone-wrapper">
											 <div class="dropzone-desc">
												 <i class="camera"></i>
												 <h6>Upload Cheque</h6>													
											 </div>
											 <input type="file" name="fileup" class="dropzone"/>
										 </div>											
									 </div> */}
								 </div>
								 
								 {/* <div class="col-12 col-lg-5">
									 <div class="file-upload">	
										 <div class="dropzone-wrapper">
											 <div class="dropzone-desc">
												 <i class="camera"></i>
												 <h6>Upload Cheque</h6>													
											 </div>
											 <input type="file" name="fileup" class="dropzone"/>
										 </div>											
									 </div>
								 </div> */}
								 {/* <div class="col-12 col-lg-7">
									 <div class="form-floating">
										 <input type="text" class="form-control" id="adhar" placeholder="Enter" value=""/>
										 <label for="adhar">Aadhaar number / VID</label>
									 </div>
								 </div>
								 
								 <div class="col-12 col-lg-5">
									 <div class="file-upload">	
										 <div class="dropzone-wrapper">
											 <div class="dropzone-desc">
												 <i class="camera"></i>
												 <h6>Upload Aadhaar</h6>													
											 </div>
											 <input type="file" name="fileup" class="dropzone"/>
										 </div>											
									 </div>
								 </div> */}
								 
								 {/* <div class="col-12">
									 <div class="formnote">Upload Aadhaar card front and back side photo</div>
								 </div> */}
								 
								 {/* <div class="col-12 col-lg-5 mt-4">
									 <div class="file-upload">	
										 <div class="dropzone-wrapper">
											 <div class="dropzone-desc">
												 <i class="camera"></i>
												 <h6>Profile Photo</h6>													
											 </div>
											 <input type="file" name="fileup" class="dropzone"/>
										 </div>											
									 </div>
								 </div>
								 
								 <div class="col-12">
									 <div class="formnote">upload your full face like it is a passport photo</div>
								 </div>									 */}
								 
								 <div class="col-12">
									 <button type="submit" class="btn btn-primary" id="">Continue</button>
								 </div>
							 </div>
						 </form>							
					 </div>
					 
					 <div class="col-12 col-lg-5">
						 <div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
					 </div>
				 </div>
			 </div>
		 </div>
	 </div>
 </div>
</div> : addnewRetailer === BANK_DEATILS ? 
<div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2>Bank Details</h2>
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onSubmit={(e)=>handleSubmit(e,BANK_DEATILS)}>
							<div class="row">
							<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select" id="type" onChange={(e)=>setSelectedbank(e.target.value)} >
											<option value="">Select</option>
											{
												allBankname.map((bank,index)=>{
													return(
														<option key={index} value={bank.id}>{bank.name}</option>	
													)
												})
											}
										</select>
										<label for="type">Bank Name</label>
									</div>
		
								</div>

								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="ifsc" placeholder="Enter IFSC" name='ifsc' onChange={(e)=>handlerInfoChnage(e,BANK_DEATILS)} value={personalDetails.accountInfo.ifsc} />
										<label for="ifsc">Enter IFSC code</label>
										<div onClick={()=>setAddNewRetailer(SEARCHIFSC)}  class="searchifsc">search ifsc</div>
									</div>									
								</div>
								
								{/* <div class="col-12 scroller">
									<div class="bankname">ICICI Bank Ltd - Gurudwara Road, Gurgaon, Haryana - ICICI006264</div>
									<div class="bankname">ICICI Bank Ltd - Gurudwara Road, Gurgaon, Haryana - ICICI006264</div>
									<div class="bankname">ICICI Bank Ltd - Gurudwara Road, Gurgaon, Haryana - ICICI006264</div>
									<div class="bankname">ICICI Bank Ltd - Gurudwara Road, Gurgaon, Haryana - ICICI006264</div>
									<div class="bankname">ICICI Bank Ltd - Gurudwara Road, Gurgaon, Haryana - ICICI006264</div>
									<div class="bankname">ICICI Bank Ltd - Gurudwara Road, Gurgaon, Haryana - ICICI006264</div>
								</div> */}
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="account1" placeholder="Enter Account" name='accNum' onChange={(e)=>handlerInfoChnage(e,BANK_DEATILS)} value={personalDetails.accountInfo.accNum}/>
										<label for="account1">Enter account number</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="add2" placeholder="Enter Address" onChange={(e)=>setConFirmAcc(e.target.value)} value= {confirmAcc} />
										<label for="add2">Confirm account number</label>
										{ confirmAcc.length > 3 && personalDetails.accountInfo.accNum !== confirmAcc &&	<small style={{color:'red'}} >Enter Account does not match</small>}
									</div>
								</div>
								
								
								
								<div class="col-12">
									<button disabled={checkBankDisable()} type="submit" class="btn btn-primary" id="">Save</button>
								</div>								
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
</div> : addnewRetailer === PASSWORD ? 
<div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2>Retailer Password</h2>
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onSubmit={(e)=>handleSubmit(e,PASSWORD)}>
							<div class="row">								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="newpass" placeholder="Enter Account" onChange={(e)=>setpassword(e.target.value)} value={password} />
										<label for="newpass">Enter Password number</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text"
	                                    class="form-control"
										id="confirmpass" 
										placeholder="Enter Address" 
										onChange={(e)=>setConfirmPassword(e.target.value)} 
										value={confirmPassword}/>
										<label for="confirmpass">Confirm Password number</label>
										{ confirmPassword.length > 2 && password !== confirmPassword &&	<small style={{color:'red'}} >Enter Password does not match</small>}
									</div>
									
								</div>
								<div class="col-12">
									<button disabled={checkPassDisable()} type="submit" class="btn btn-primary"  id="">Submit</button>
								</div>								
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
</div> : addnewRetailer === SEARCHIFSC ? <div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2>Bank IFSC code</h2>
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onSubmit={submitIfsc} >
							<div class="row">
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select" id="type" onChange={(e)=>setSelectedbank(e.target.value)} >
											{/* <option value="">Select</option>
											<option value="1">Bank1</option>
											<option value="2">Bank2</option>
											<option value="3">Bank3</option> */}
											<option value="">Select</option>
											{
												allBankname.map((bank,index)=>{
													return(
														<option key={index} value={bank.id}>{bank.name}</option>	
													)
												})
											}
										</select>
										<label for="type">Bank Name</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">						
									<div class="form-floating">
										<select class="form-select" id="state" onChange={cityHandler}  >
											<option value="">Select</option>
																				
											{
											 Array.isArray(stateDetails) && stateDetails.map((state, ind)=>{
											
												return( <option key={ind} value={ind}  >{state.name}</option>)
											 })
											}
										</select>
										<label for="state">Select state</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select" id="city" onChange={banchHandler} >
										<option value="">Select</option>
											{
												Array.isArray(cities) && cities.length > 0 && cities.map((city,index)=>{
													return <option key={index} value={index}>{city.name}</option>
												})
											}

										</select>
										<label for="city">City Name</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select" id="branch" onChange={ifscHandler}>
											<option value="">Select</option>
											{/* <option value="1">Branch1</option>
											<option value="2">Branch2</option>
											<option value="3">Branch3</option> */}
											{
												Array.isArray(branches) && branches.length > 0 && branches.map((branch, ind)=>{
													return <option value={ind}>{branch.name}</option>
												})
											}
										</select>
										<label for="branch">Branch Name</label>
									</div>
								</div>
								
								<div class="col-12">
									<div class="bankname">IFSC Code:  {personalDetails.accountInfo.ifsc}</div>
								</div>
								
								<div class="col-12">
									<button disabled={personalDetails.accountInfo.ifsc == ''} type="submit" class="btn btn-primary"   >Okey</button>
								</div>								
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
</div>: addnewRetailer === USERCREATED ?
 <div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2>Congratulations</h2>
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onSubmit={nextPage} >
							<div class="row">								
								<div class="col-12">
									<div class="successtxt">
									<p>Dear <strong>{personalDetails.personalInfo.fname}</strong>,</p>
									<p>Welcome to FinXpay, Now login to FinXpay App with RO code & password sent to your registered mobile number: +91-{personalDetails.personalInfo.mobile}</p>
									<p>Your basic profile details has been captured. To avail more services and earn more.</p>
									<p><strong>Happy Earning.</strong></p>
									
									<h6><img src={require('../../assests/images/icon.png')} alt=""/> RO Code: {roCode?.roid !== undefined && roCode?.roid} </h6>
									<h6><img src="images/icon.png" alt=""/>{roCode?.clientDetails !== undefined && roCode?.clientDetails} </h6>
									</div>
								</div>								
								<div class="col-12">
									<button type="submit" class="btn btn-primary" id="">Next</button>
								</div>								
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block">
							<div class="rightbanner"><img src={require('../../assests/images/success-img.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
</div> :''

	}
   

</React.Fragment>
  )
}
